import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HeaderTabs } from "../components";
import { setPageTitle } from "../helper/metaDataHelper";
import TransactionHistory from "./components/TransactionHistory";

const TransactionHistoryPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setPageTitle("Transaction History");
  }, []);

  return (
    <main className="font-outfit max-sm:bg-background-surface">
      <div className="mx-auto flex w-full max-w-[1141px] flex-col max-sm:min-h-[calc(100dvh-8.5rem)] max-sm:px-0 sm:min-h-screen sm:px-4">
        <div className="flex flex-1 flex-col max-sm:min-h-0 sm:space-y-4">
          <div className="max-sm:hidden">
            <HeaderTabs />
          </div>
          <TransactionHistory onPageBack={() => navigate("/v2/crypto")} />
        </div>
      </div>
    </main>
  );
};

export default TransactionHistoryPage;
